import { camelCase } from './changeCaseMirror.js';
export const idFromFilename = (filename) => {
    return `icon-${filename.replace(/--/g, '-')}`;
};
export const normalizeComponentName = (id) => {
    return id.replace('tds-', '').replace('_', '');
};
export const prefixIdName = (id) => {
    return `tds-${id}`;
};
export const normalizeExportFilename = (id) => {
    return id.replace('tds-', '');
};
export const fileNameToIconName = (filename) => {
    return `icon-${filename.replace(/--/g, '-')}`;
};
export const nameToKey = (name) => camelCase(name).replace('_', '');
export const nameToID = (name) => `tds-${name}`;
export const registryToKeyArray = (registry) => {
    const arr = [];
    registry.forEach((icon) => {
        var _a;
        (_a = icon.variants) === null || _a === void 0 ? void 0 : _a.forEach((variant) => {
            arr.push(nameToKey(variant.id));
        });
    });
    return arr;
};
export const registryToIDArray = (registry) => {
    const arr = [];
    registry.forEach((icon) => {
        var _a;
        (_a = icon.variants) === null || _a === void 0 ? void 0 : _a.forEach((variant) => {
            arr.push(nameToID(variant.id));
        });
    });
    return arr;
};
export const registryToVariantsArray = (registry) => {
    const arr = [];
    registry.forEach((icon) => {
        var _a;
        (_a = icon.variants) === null || _a === void 0 ? void 0 : _a.forEach((variant) => {
            arr.push(variant);
        });
    });
    return arr;
};
